(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.Actions = {
        events: {
            add: function() {
                $(function () {
                    $('[data-open="fast-call"]').on('click', Actions.modals.fastcall);
                    $('#modal-fastcall #fast-call-number').on('click', Actions.modals.startFastcall);
                    $('[data-open="request"]').on('click', Actions.modals.request);
                    $('#modal-request #form-request').on('submit', Actions.modals.submit);
                });
            },
        },
        modals: {
            reference: null,
            fastcall: function(e) {
                e.preventDefault();
                $.post(
                    '//' + window.location.hostname + '/ajax/professional/fastcall',
                    {
                        _token: $('meta[name="csrf-token"]').prop('content'),
                        id: $(this).data('id'),
                    },
                    function( result ) {
                        $('#modal-fastcall #fast-call-name').html(result.data.professional + ' - ' + result.data.office.name);
                        $('#modal-fastcall #fast-call-number')
                            .prop('href', 'tel:' + result.data.office.fast_call_phone_number)
                            .html(result.data.office.fast_call_phone_number);
                        (new bootstrap.Modal(document.getElementById('modal-fastcall'))).show();
                    },
                    "json"
                );
            },
            startFastcall: function () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'richiesta_logged_user',
                    'contact_method': 'phone_call'
                });
            },
            request: function(e) {
                e.preventDefault();
                let id = $(this).data('id');
                $.post(
                    '//' + window.location.hostname + '/ajax/professional/request',
                    {
                        _token: $('meta[name="csrf-token"]').prop('content'),
                        id: id,
                    },
                    function( result ) {
                        $('#modal-request #request_office_id').val(id);
                        $('#modal-request #request-name').html(result.data.professional.name);
                        $('#modal-request #request_service_id')
                            .html('')
                            .html(result.data.options);

                        Actions.modals.reference = new bootstrap.Modal(document.getElementById('modal-request'));
                        Actions.modals.reference.show();
                    },
                    "json"
                );
            },
            submit: function(e) {
                $.post(
                    '//' + window.location.hostname + '/ajax/professional/request/submit',
                    {
                        _token: $('meta[name="csrf-token"]').prop('content'),
                        office_id: $('#modal-request #request_office_id').val(),
                        location: $('#modal-request [name="l"]').val(),
                        address: $('#modal-request [name="a"]').val(),
                        zip_code: $('#modal-request [name="z"]').val(),
                        city: $('#modal-request [name="c"]').val(),
                        province: $('#modal-request [name="p"]').val(),
                        nation: $('#modal-request [name="n"]').val(),
                        service_id: $('#modal-request #request_service_id').val(),
                        message: $('#modal-request #request_message').val(),
                    },
                    function( result ) {
                        $('[data-button="' + $('#modal-request #request_office_id').val() + '"]').hide();
                        $('#modal-request-completed #modal-request-completed-name').html(result.data.professional.name);
                        Actions.modals.reference.hide();
                        Actions.modals.reference = null;
                        (new bootstrap.Modal(document.getElementById('modal-request-completed'))).show();
                    },
                    "json"
                );

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'richiesta_logged_user',
                    'contact_method': 'contact_form'
                });

                return false;
            },
        },
        init: function() {
            Actions.events.add();
        }
    };

})));
